(function () {
  'use strict';
  var ease = 'cubic-bezier(.32,.72,0,1)';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function money(c) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en',
      { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD' }).format(c / 100); }
    catch (e) { return (c / 100).toFixed(2); }
  }

  /* ---------- reveal on scroll ---------- */
  function reveal() {
    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion:reduce)').matches) {
      $$('.rise,.anim').forEach(function (e) { e.classList.add('seen'); }); return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('seen'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -12% 0px', threshold: .08 });
    $$('.rise,.anim').forEach(function (e) { io.observe(e); });
  }

  /* ---------- counters ---------- */
  function counters() {
    $$('[data-count]').forEach(function (el) {
      var target = parseFloat(el.dataset.count); if (isNaN(target)) return;
      var done = false;
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting || done) return; done = true;
          var t0 = performance.now(), dur = 900;
          (function step(t) {
            var k = Math.min(1, (t - t0) / dur), v = Math.round(target * (1 - Math.pow(1 - k, 3)));
            el.textContent = v; if (k < 1) requestAnimationFrame(step);
          })(t0);
        });
      }, { threshold: .4 });
      io.observe(el);
    });
  }

  /* ---------- slider ---------- */
  function slider() {
    var root = $('#slider'); if (!root) return;
    var slides = $$('.slide', root), dots = $$('.dot', root), i = 0, timer = null;
    var PERIOD = 6400;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('on', k === i); });
      root.classList.toggle('s-ink', slides[i].classList.contains('s-ink'));
      dots.forEach(function (d, k) {
        d.classList.toggle('on', k === i);
        d.setAttribute('aria-selected', String(k === i));
      });
    }
    function play() { if (!root.classList.contains('auto') || slides.length < 2) return; stop(); timer = setInterval(function () { go(i + 1); }, PERIOD); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    $$('[data-step]', root).forEach(function (b) { b.addEventListener('click', function () { go(i + (+b.dataset.step)); play(); }); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.dataset.go); play(); }); });
    root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', play);
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); play(); } x0 = null;
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (!root.getBoundingClientRect().height) return;
      if (e.key === 'ArrowRight') { go(i + 1); play(); }
      if (e.key === 'ArrowLeft') { go(i - 1); play(); }
    });
    go(0); play();
  }


  /* ---------- four weeks, paged by the scroll ---------- */
  function weeks() {
    var stage = $('.wkstage'); if (!stage) return;
    var row = $('.wk4', stage); if (!row) return;
    var cards = $$('.wk', row); if (!cards.length) return;
    var n = cards.length, live = false, want = 0, have = 0, raf = 0, lraf = 0;
    var still = matchMedia('(prefers-reduced-motion:reduce)').matches;

    /* a real scene in each week (water pours, a seed grows, sand runs): the scroll is its clock */
    var F = cards.map(function (c) {
      var v = $('.wkvid', c); if (!v) return null;
      var o = { v: v, dur: 0, at: -1, x: 0, woke: false, dead: false, pos: '' };
      v.addEventListener('loadedmetadata', function () { o.dur = v.duration || 0; o.at = -1; seek(o); });
      /* a browser that cannot play it still gets the start and the end of the scene */
      function dead() { o.dead = true; pose(o); }
      v.addEventListener('error', dead);
      var src = $('source', v); if (src) src.addEventListener('error', dead);
      return o;
    });
    function pose(o) {
      var u = o.x > 0.5 ? o.v.dataset.end : o.v.dataset.start;
      if (u && u !== o.pos) { o.pos = u; o.v.poster = u; }
    }
    var films = F.filter(Boolean);
    function seek(o) {
      if (!o.dur) return;
      var t = o.x * (o.dur - 0.05);
      if (Math.abs(t - o.at) < 0.02) return;
      o.at = t;
      try { o.v.currentTime = t; } catch (e) {}
    }
    function film(i, x) {
      var o = F[i]; if (!o) return;
      o.x = x < 0 ? 0 : x > 1 ? 1 : x;
      if (o.dead) pose(o); else seek(o);
    }
    /* Safari shows no seek on a video that has never been told to play */
    function wake(o) {
      if (o.woke) return; o.woke = true;
      var v = o.v;
      if (v.dataset.start && o.x < 1) v.poster = v.dataset.start;
      v.preload = 'auto';
      var q = v.play();
      if (q && q.then) q.then(function () { v.pause(); o.at = -1; seek(o); }).catch(function () {});
    }
    if (films.length && !still) {
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es, ob) {
          if (es.some(function (e) { return e.isIntersecting; })) { films.forEach(wake); ob.disconnect(); }
        }, { rootMargin: '700px 0px' }).observe(stage);
      } else films.forEach(wake);
    }

    function able() {
      return window.innerWidth > 900 && !still;
    }
    function read() {
      var run = stage.offsetHeight - window.innerHeight;
      if (run <= 0) return 1;
      var p = -stage.getBoundingClientRect().top / run;
      return p < 0 ? 0 : p > 1 ? 1 : p;
    }
    function paint(p) {
      row.style.setProperty('--p', p.toFixed(4));
      var head = p * n - 0.5;                      /* the week the scroll is on */
      for (var i = 0; i < n; i++) {
        var d = Math.abs(head - i);
        var a = d >= 1 ? 0 : 1 - d;
        a = a * a * (3 - 2 * a);                   /* smoothstep: grows and settles */
        var f = (head - i + 1) * 2;                /* the colour pours in just before its week */
        f = f < 0 ? 0 : f > 1 ? 1 : f;
        cards[i].style.setProperty('--a', a.toFixed(3));
        cards[i].style.setProperty('--f', f.toFixed(3));
        film(i, head - i + 0.5);                   /* and the scene plays out across its seven days */
      }
    }
    function step() {
      raf = 0;
      have += (want - have) * 0.16;                /* a little weight, never a snap */
      if (Math.abs(want - have) < 0.0004) have = want;
      paint(have);
      if (have !== want) queue();
    }
    function queue() { if (!raf) raf = requestAnimationFrame(step); }

    /* narrow screens: each scene plays as its card crosses the screen */
    function local() {
      lraf = 0;
      var vh = window.innerHeight;
      for (var i = 0; i < n; i++) {
        if (!F[i]) continue;
        var r = cards[i].firstElementChild.getBoundingClientRect();
        film(i, (vh * 0.92 - r.top) / (vh * 0.56));
      }
    }
    function tick() {
      if (live) { want = read(); queue(); }
      else if (films.length && !still && !lraf) lraf = requestAnimationFrame(local);
    }
    function on() {
      if (live) return;
      live = true;
      row.classList.add('live');
      row.classList.remove('anim', 'seen');
      have = want = read(); paint(have);
    }
    function off() {
      if (!live) return;
      live = false;
      row.classList.remove('live');
      row.classList.add('anim', 'seen');
      row.style.removeProperty('--p');
      cards.forEach(function (c) {
        c.style.removeProperty('--a'); c.style.removeProperty('--f');
      });
    }
    function sync() { if (able()) on(); else off(); }

    sync(); tick();
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', function () { sync(); tick(); });
  }


  /* ---------- the product reel, scrubbed by the scroll ---------- */
  function reel() { $$('.reel').forEach(scrub); }

  function scrub(sec) {
    var vid = $('.reelvid', sec); if (!vid) return;
    var pin = $('.reelpin', sec);
    var dur = 0, live = false, want = 0, have = 0, raf = 0, primed = false, freed = false;
    var scrs = $$('.scr', sec), strip = false;
    var screens = scrs.length || 3;
    var STARTS = screens === 1 ? [0] : (screens === 2 ? [0, 0.50] : [0, 0.29, 0.68]);
    if (!sec.getAttribute('data-n')) sec.setAttribute('data-n', screens);

    /* phones scrub too - only a stated preference for less motion turns it off */
    function able() {
      return !matchMedia('(prefers-reduced-motion:reduce)').matches;
    }
    /* where the copy is too long to page a screen at a time, the film pins on its own
       and the blocks scroll under it - the stylesheet says which layout is in force */
    function shape() {
      strip = !!pin && getComputedStyle(pin).position === 'static';
    }
    function read() {
      /* the pinned panel, not the window, is what the film is measured against:
         on a phone the two differ every time the address bar hides */
      var hold = strip || !pin ? window.innerHeight : pin.offsetHeight;
      var run = sec.offsetHeight - hold;
      if (run <= 0) return 0;
      var p = -sec.getBoundingClientRect().top / run;
      return p < 0 ? 0 : p > 1 ? 1 : p;
    }
    function paint(p) {
      sec.style.setProperty('--p', p.toFixed(4));
      var k, q;
      if (strip) {
        /* every block runs its own stagger as it comes up the screen */
        sec.removeAttribute('data-screen');
        var vh = window.innerHeight;
        for (k = 0; k < scrs.length; k++) {
          q = (vh - scrs[k].getBoundingClientRect().top) / (vh * 0.42);
          scrs[k].style.setProperty('--q', (q < 0 ? 0 : q > 1 ? 1 : q).toFixed(3));
        }
      } else {
        sec.setAttribute('data-screen', screens === 1 ? '1' : (screens === 2 ? (p < 0.48 ? '1' : '2') : (p < 0.28 ? '1' : p < 0.67 ? '2' : '3')));
        /* each screen gets its own 0..1 so its lines can arrive one after another */
        for (k = 0; k < screens; k++) {
          if (!scrs[k]) continue;
          q = (p - STARTS[k]) / 0.16;
          scrs[k].style.setProperty('--q', (q < 0 ? 0 : q > 1 ? 1 : q).toFixed(3));
        }
      }
      if (!dur || freed) return;
      /* the film finishes a little before the end, so the last screen reads on a still */
      var t = Math.min(1, p / 0.84) * (dur - 0.06);
      if (Math.abs(vid.currentTime - t) > 0.025) { try { vid.currentTime = t; } catch (e) {} }
    }
    function step() {
      raf = 0;
      have += (want - have) * 0.13;
      if (Math.abs(want - have) < 0.0004) have = want;
      paint(have);
      if (have !== want) queue();
    }
    function queue() { if (!raf) raf = requestAnimationFrame(step); }
    function tick() { if (live) { want = read(); queue(); } }

    function meta() {
      dur = vid.duration || 0;
      if (live) { have = want = read(); paint(have); }
    }
    if (vid.readyState >= 1) meta();
    vid.addEventListener('loadedmetadata', meta);

    /* some phones and Safari will not seek a video that has never been told to play */
    function prime() {
      if (primed) return; primed = true;
      var q = vid.play();
      if (q && q.then) q.then(function () { if (able()) vid.pause(); }).catch(function () {});
      /* and a few refuse to seek at all: rather than hold a frozen frame, let the
         film run itself and keep the copy on the scroll */
      setTimeout(function () {
        if (freed || !live || want < 0.08) return;
        if (vid.currentTime > 0.05) return;
        freed = true; vid.loop = true;
        var r = vid.play(); if (r && r.catch) r.catch(function () {});
      }, 2200);
    }

    function on() {
      if (live) return; live = true; vid.loop = false; vid.pause();
      shape(); have = want = read(); paint(have);
      if (vid.preload !== 'none') prime();
    }
    function off() {
      if (!live && primed) return;
      live = false; sec.style.removeProperty('--p'); sec.removeAttribute('data-screen');
      scrs.forEach(function (e) { e.style.removeProperty('--q'); });
    }
    function sync() { if (able()) on(); else off(); }

    /* on a phone it is not scrubbed - it plays itself once when it comes into view */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting || able()) return;
          var q = vid.play(); if (q && q.catch) q.catch(function () {});
        });
      }, { threshold: .25 }).observe(sec);
    }

    /* a second film on the same page is not worth its megabytes until it is near */
    if (vid.getAttribute('preload') === 'none' && 'IntersectionObserver' in window) {
      var lio = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        lio.disconnect(); vid.preload = 'auto';
        try { vid.load(); } catch (e) {}
        if (live) prime();
      }, { rootMargin: '140% 0px' });
      lio.observe(sec);
    }

    sync(); tick();
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', function () { sync(); tick(); });
  }

  /* ---------- product media ---------- */
  function media() {
    var stage = $('.mstage'); if (!stage) return;
    var img = $('.stageImg'), vid = $('.stageVid'), cap = $('.gcap'), sect = $('.pdpmedia') || $('.media');
    var btns = $$('.rail button', sect || stage);
    function sizeRail() {
      if (!sect) return;
      if (window.innerWidth <= 1000) { sect.style.removeProperty('--tb'); return; }
      var wide = sect.classList.contains('media');
      var inset = wide ? Math.min(56, Math.max(24, window.innerWidth * 0.032)) : 36;
      var gap = wide ? 9 : 8;
      var n = btns.length || 1;
      var cap = wide ? 112 : 84;
      var t = Math.max(46, Math.min(cap, Math.floor((stage.getBoundingClientRect().height - inset - 8 - gap * (n - 1)) / n)));
      sect.style.setProperty('--tb', t + 'px');
    }
    function capHtml(text) {
      if (!text) return '';
      var k = text.indexOf('. ');
      if (k < 0) return text;
      return '<b>' + text.slice(0, k + 1) + '</b> ' + text.slice(k + 2);
    }
    function pick(n) {
      var b = btns[n]; if (!b) return;
      btns.forEach(function (x, k) { x.setAttribute('aria-current', k === n ? 'true' : 'false'); });
      if (cap) cap.innerHTML = capHtml(b.dataset.cap || '');
      if (b.dataset.video) {
        stage.classList.add('vid');
        if (vid) { try { vid.play(); } catch (e) {} }
      } else {
        stage.classList.remove('vid');
        if (vid) { try { vid.pause(); } catch (e) {} }
        if (img) { img.style.opacity = '0'; setTimeout(function () { img.src = b.dataset.src; img.style.opacity = '1'; }, 160); }
      }
    }
    btns.forEach(function (b, n) {
      b.addEventListener('click', function () { pick(n); });
      b.addEventListener('mouseenter', function () { if (!b.dataset.video) pick(n); });
    });
    sizeRail(); window.addEventListener('resize', sizeRail);
    if (window.ResizeObserver) new ResizeObserver(sizeRail).observe(stage);
  }

  /* ---------- gram bar ---------- */
  function grams() {
    var bars = $$('.bar [role="tab"]'), rows = $$('.pl');
    if (!bars.length) return;
    function pick(i) {
      bars.forEach(function (b) { b.setAttribute('aria-selected', b.dataset.i === String(i)); });
      rows.forEach(function (r) { r.setAttribute('aria-selected', r.dataset.i === String(i)); });
    }
    bars.concat(rows).forEach(function (el) {
      el.addEventListener('click', function () { pick(+el.dataset.i); });
    });
  }

  /* ---------- variants ---------- */
  function variants() {
    var form = $('#buyForm'); if (!form) return;
    var sel = $('[data-variants]', form);
    var price = $('[data-price]'), sku = $('[data-sku]'), addTxt = $('[data-add-text]'), add = $('[data-add]', form);
    function sync() {
      var opts = $$('[data-opt]:checked', form).map(function (r) { return r.value; });
      var match = null;
      $$('option', sel).forEach(function (o) {
        var t = o.textContent.split(' / ').map(function (s) { return s.trim(); });
        if (opts.length && opts.every(function (v, k) { return t[k] === v; })) match = o;
      });
      if (!match) match = sel.options[sel.selectedIndex] || sel.options[0];
      sel.value = match.value;
      if (price) price.textContent = match.dataset.price;
      if (sku) sku.textContent = match.dataset.sku || '';
      var was = $('[data-compare]');
      if (was) { if (match.dataset.compare) { was.textContent = match.dataset.compare; was.hidden = false; } else { was.hidden = true; } }
      var off = $('[data-off]');
      if (off) { if (match.dataset.off) { off.textContent = '\u2212' + match.dataset.off + '%'; off.hidden = false; } else { off.hidden = true; } }
      $$('.optrow').forEach(function (row) {
        var b = $('.olabel b', row), on = $('.opt input:checked', row);
        if (b && on) b.textContent = on.value;
      });
      var ok = match.dataset.available === 'true';
      if (add) add.disabled = !ok;
      if (addTxt) addTxt.textContent = ok ? 'Add to cart' : 'Sold out';
      $$('.opt', form).forEach(function (l) { l.classList.toggle('on', !!$('input:checked', l)); });
      var u = new URL(location.href); u.searchParams.set('variant', match.value);
      history.replaceState({}, '', u);
    }
    $$('[data-opt]', form).forEach(function (r) { r.addEventListener('change', sync); });
    sync();
  }

  /* ---------- quantity ---------- */
  function qty() {
    $$('[data-q]').forEach(function (b) {
      b.addEventListener('click', function () {
        var box = b.closest('.qty'), f = $('input.qv', box) || $('.qv', box);
        if (!f) return;
        var cur = parseInt(f.value || f.textContent, 10) || 1;
        var next = Math.max(1, Math.min(99, cur + (+b.dataset.q)));
        if ('value' in f && f.tagName === 'INPUT') f.value = next; else f.textContent = next;
      });
    });
  }

  /* ---------- cart ---------- */
  var Cart = {
    open: function () { var d = $('#drawer'); if (!d) return; d.hidden = false; requestAnimationFrame(function () { d.classList.add('on'); }); document.body.style.overflow = 'hidden'; this.load(); },
    close: function () { var d = $('#drawer'); if (!d) return; d.classList.remove('on'); document.body.style.overflow = ''; setTimeout(function () { d.hidden = true; }, 360); },
    count: function (n) { $$('[data-cart-count]').forEach(function (e) { e.textContent = n; e.classList.toggle('has', n > 0); }); },
    render: function (c) {
      this.count(c.item_count);
      var t = $('[data-cart-total]'); if (t) t.textContent = money(c.total_price);
      var dr = $('[data-cart-disc]');
      if (dr) {
        dr.hidden = !c.total_discount;
        var da = $('[data-cart-disc-amt]', dr); if (da) da.textContent = '\u2212' + money(c.total_discount || 0);
        var dc = $('[data-cart-disc-code]', dr); if (dc) dc.textContent = (c.cart_level_discount_applications || []).map(function (a) { return a.title; }).join(', ');
      }
      if (typeof Promo !== 'undefined' && Promo.boxes.length) Promo.state(c);
      var list = $('#cartList'); if (!list) return;
      if (!c.items.length) { list.innerHTML = '<p class="t-body">Your cart is empty</p>'; return; }
      list.innerHTML = c.items.map(function (it) {
        return '<div class="citem" data-key="' + it.key + '">' +
          '<a class="th" href="' + it.url + '">' + (it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/, '_260x$1$2') + '" alt="" width="260" height="260">' : '') + '</a>' +
          '<div><a href="' + it.url + '"><b>' + it.product_title + '</b></a>' +
          (it.variant_title ? '<p class="t-small">' + it.variant_title + '</p>' : '') + '</div>' +
          '<div class="qty"><button type="button" data-ck="' + it.key + '" data-d="-1">&minus;</button>' +
          '<span class="qv num">' + it.quantity + '</span>' +
          '<button type="button" data-ck="' + it.key + '" data-d="1">+</button></div>' +
          '<span class="num">' + money(it.final_line_price) + '</span>' +
          '<button type="button" class="rm" data-ck="' + it.key + '" data-d="0" aria-label="Remove">&times;</button></div>';
      }).join('');
      this.xsell(c);
      $$('[data-ck]', list).forEach(function (b) {
        b.addEventListener('click', function () {
          var row = b.closest('.citem'), cur = parseInt($('.qv', row).textContent, 10) || 1;
          var d = +b.dataset.d, next = d === 0 ? 0 : Math.max(0, cur + d);
          Cart.change(b.dataset.ck, next);
        });
      });
    },
    /* the drawer renders every candidate hidden; show the ones not in the cart */
    xsell: function (c) {
      var box = $('#drawer [data-xsell]'); if (!box) return;
      var have = {}; c.items.forEach(function (it) { have[it.product_id] = 1; });
      var max = parseInt(box.dataset.max, 10) || 1, n = 0;
      $$('[data-xs]', box).forEach(function (card) {
        var pick = !have[card.dataset.pid] && n < max;
        card.hidden = !pick; if (pick) n++;
      });
      box.hidden = n === 0;
    },
    load: function () { fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); }).then(Cart.render.bind(Cart)); },
    change: function (key, q) {
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: q })
      }).then(function (r) { return r.json(); }).then(Cart.render.bind(Cart));
    },
    add: function (form) {
      var fd = new FormData(form);
      var btn = $('[data-add]', form); if (btn) btn.disabled = true;
      return fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: fd })
        .then(function (r) { return r.json(); })
        .then(function () { if (btn) btn.disabled = false; Cart.open(); })
        .catch(function () { if (btn) btn.disabled = false; form.submit(); });
    }
  };

  function cart() {
    if (!window.Shopify || !window.Shopify.routes) window.Shopify = Object.assign(window.Shopify || {}, { routes: { root: '/' } });
    var btn = $('#cartBtn'); if (btn) btn.addEventListener('click', function () { Cart.open(); });
    $$('#drawer [data-close]').forEach(function (b) { b.addEventListener('click', function () { Cart.close(); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') Cart.close(); });
    var form = $('#buyForm');
    if (form) {
      form.addEventListener('submit', function (e) { e.preventDefault(); Cart.add(form); });
      var sb = $('[data-sbar-add]');
      if (sb) sb.addEventListener('click', function () { Cart.add(form); });
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-xadd]') : null; if (!b) return;
      b.disabled = true;
      var inDrawer = !!b.closest('#drawer');
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: +b.dataset.xadd, quantity: 1 }] })
      }).then(function () {
        /* in the drawer: refresh it; elsewhere: open it on what was just added, no reload */
        b.disabled = false;
        if (inDrawer) Cart.load(); else if ($('#drawer')) Cart.open(); else location.reload();
      }).catch(function () { b.disabled = false; });
    });
    $$('.cartform [data-line-q], .cartform [data-remove]').forEach(function (b) {
      b.addEventListener('click', function () {
        var row = b.closest('.citem'), cur = parseInt($('.qv', row).textContent, 10) || 1;
        var q = b.hasAttribute('data-remove') ? 0 : Math.max(0, cur + (+b.dataset.lineQ));
        fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: row.dataset.key, quantity: q })
        }).then(function () { location.reload(); });
      });
    });
  }

  /* ---------- sticky buy bar ---------- */
  function sbar() {
    var bar = $('#sbar'), anchor = $('#buy'); if (!bar || !anchor) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { bar.classList.toggle('on', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* a country the visitor picks is theirs — the geo check in the layout never overrides it */
  function remember(code) { try { localStorage.setItem('7vit.country', code); } catch (e) {} }

  /* ---------- card rails ---------- */
  function rails() {
    $$('[data-roll]').forEach(function (rail) {
      var box = rail.closest('.cardsbox'); if (!box) return;
      var btns = $$('[data-roll-step]', box);
      function step() {
        var first = rail.firstElementChild;
        if (!first) return rail.clientWidth;
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        return first.getBoundingClientRect().width + gap;
      }
      function sync() {
        var max = rail.scrollWidth - rail.clientWidth - 2;
        btns.forEach(function (b) {
          if (+b.dataset.rollStep < 0) b.disabled = rail.scrollLeft <= 2;
          else b.disabled = rail.scrollLeft >= max;
        });
      }
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          rail.scrollBy({ left: step() * (+b.dataset.rollStep), behavior: 'smooth' });
        });
      });
      rail.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* ---------- menus ---------- */
  function menus() {
    var mb = $('#menuBtn'), mega = $('#mega');
    if (mb && mega) {
      var shutT = null;
      var open = function () {
        if (shutT) { clearTimeout(shutT); shutT = null; }
        mega.hidden = false;
        requestAnimationFrame(function () { mega.classList.add('on'); });
        mb.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        var c = $('.close', mega); if (c) c.focus();
      };
      var shut = function () {
        mega.classList.remove('on');
        mb.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        shutT = setTimeout(function () { mega.hidden = true; shutT = null; }, 520);
      };
      mb.addEventListener('click', function () { if (mega.classList.contains('on')) shut(); else open(); });
      $$('[data-mega-close]', mega).forEach(function (b) { b.addEventListener('click', shut); });
      mega.addEventListener('click', function (e) { if (e.target === mega) shut(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && mega.classList.contains('on')) shut(); });
    }
    var cur = $('[data-cur]');
    if (cur) {
      var list = $('.curlist');
      var shutCur = function () { list.hidden = true; cur.setAttribute('aria-expanded', 'false'); };
      cur.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = list.hidden;
        list.hidden = !open;
        cur.setAttribute('aria-expanded', String(open));
        if (open) { var on = $('button[aria-current="true"]', list); if (on) on.scrollIntoView({ block: 'nearest' }); }
      });
      document.addEventListener('click', function (e) { if (!list.hidden && !list.contains(e.target)) shutCur(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !list.hidden) { shutCur(); cur.focus(); } });
    }
    var csel = $('[data-cur-select]');
    if (csel) csel.addEventListener('change', function () { remember(csel.value); csel.form.submit(); });
    $$('.curlist button[name="country_code"]').forEach(function (b) {
      b.addEventListener('click', function () { remember(b.value); });
    });
  }

  /* ---------- selling-block questions ---------- */
  function sellfaq() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.sb-q') : null; if (!b) return;
      var qa = b.parentElement;
      var open = qa.classList.toggle('open');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- the pack behind the comparison table ---------- */
  function cmpbg() {
    var root = $('.sb-cmp'); if (!root) return;
    var layer = $('.sb-cmpbg', root); if (!layer) return;
    if (matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    var waiting = false;
    function paint() {
      var r = root.getBoundingClientRect(), vh = window.innerHeight;
      var p = (vh - r.top) / (r.height + vh);
      p = p < 0 ? 0 : (p > 1 ? 1 : p);
      layer.style.transform = 'translate3d(0,' + ((p - .5) * -64).toFixed(1) + 'px,0)';
    }
    function queue() { if (waiting) return; waiting = true; requestAnimationFrame(function () { paint(); waiting = false; }); }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    paint();
  }

  /* ---------- the torn pouch beside the questions ---------- */
  function qfilm() {
    var sec = $('.sb-qsec.has-film'); if (!sec) return;
    var vid = $('.sb-qvid', sec), grid = $('.sb-qgrid', sec), film = $('.sb-qfilm', sec);
    var items = $$('.sb-qa', sec);
    var wideQ = matchMedia('(min-width:1000px)');

    /* the question crossing the middle of the screen is the one in focus */
    if ('IntersectionObserver' in window && items.length) {
      var lit = items[0];
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          if (lit && lit !== e.target) lit.classList.remove('on');
          lit = e.target; lit.classList.add('on');
        });
      }, { rootMargin: wideQ.matches ? '-44% 0px -44% 0px' : '-64% 0px -30% 0px', threshold: 0 });
      items.forEach(function (it) { io.observe(it); });
    }

    if (!vid || !grid || !film) return;
    if (matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    var dur = 0, want = 0, have = 0, raf = 0, primed = false;

    function read() {
      /* exactly the stretch where the film is pinned (beside the questions, or as the band on a phone):
         it starts when it sticks and is done a little before it lets go */
      var g = grid.getBoundingClientRect(), f = film.getBoundingClientRect();
      var top = parseFloat(getComputedStyle(film).top) || 0;
      var run = (g.height - f.height) * (wideQ.matches ? 1 : 0.8);
      if (run <= 0) return 0;
      var p = (top - g.top) / run;
      return p < 0 ? 0 : p > 1 ? 1 : p;
    }
    function paint() {
      if (!dur) return;
      var t = have * (dur - 0.04);
      if (Math.abs(vid.currentTime - t) > 0.015) { try { vid.currentTime = t; } catch (e) {} }
    }
    function step() {
      raf = 0;
      have += (want - have) * 0.14;
      if (Math.abs(want - have) < 0.0004) have = want;
      paint();
      if (have !== want) raf = requestAnimationFrame(step);
    }
    function queue() { stickTops(); want = read(); if (!raf) raf = requestAnimationFrame(step); }
    /* Safari will not show a seek on a video that has never been told to play */
    function prime() {
      if (primed) return; primed = true;
      var q = vid.play();
      if (q && q.then) q.then(function () { vid.pause(); queue(); }).catch(function () {});
    }
    function meta() { dur = vid.duration || 0; queue(); }
    if (vid.readyState >= 1) meta();
    vid.addEventListener('loadedmetadata', meta);
    var near = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) prime(); });
    }, { rootMargin: '300px 0px' });
    near.observe(sec);
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
  }

  /* the seven plants: the one under the pointer blooms and closes again when it leaves;
     without a pointer (a phone) each one blooms as it comes into view */
  function bloom() {
    var row = $('.sevrow'); if (!row) return;
    var still = matchMedia('(prefers-reduced-motion:reduce)').matches;
    var list = [];
    $$('.sev', row).forEach(function (c) {
      var v = $('.sevvid', c); if (!v) return;
      if (still) { if (v.dataset.end) v.poster = v.dataset.end; return; }
      var o = { c: c, v: v, dur: 0, x: 0, goal: 0, at: -1, raf: 0, t: 0, woke: false, dead: false, start: v.poster };
      v.addEventListener('loadedmetadata', function () { o.dur = v.duration || 0; o.at = -1; seek(o); });
      /* a browser that cannot play it swaps the two stills instead */
      function dead() { o.dead = true; }
      v.addEventListener('error', dead);
      var src = $('source', v); if (src) src.addEventListener('error', dead);
      o.f = function (now) {
        var dt = o.t ? Math.min(0.05, (now - o.t) / 1000) : 0.016; o.t = now;
        var d = o.goal - o.x, k = dt * (d > 0 ? 1 / 1.6 : 1 / 1.0);   /* opens in 1.6s, closes in 1s */
        o.x = Math.abs(d) <= k ? o.goal : o.x + (d > 0 ? k : -k);
        seek(o);
        if (o.x !== o.goal) o.raf = requestAnimationFrame(o.f); else { o.raf = 0; o.t = 0; }
      };
      list.push(o);
    });
    if (!list.length) return;
    function seek(o) {
      if (!o.dur) return;
      var t = o.x * (o.dur - 0.05);
      if (Math.abs(t - o.at) < 0.02) return;
      o.at = t;
      try { o.v.currentTime = t; } catch (e) {}
    }
    /* Safari shows no seek on a video that has never been told to play */
    function wake(o) {
      if (o.woke) return; o.woke = true;
      var v = o.v; v.preload = 'auto';
      var q = v.play();
      if (q && q.then) q.then(function () { v.pause(); o.at = -1; seek(o); }).catch(function () {});
    }
    function to(o, g) {
      o.goal = g; wake(o);
      if (o.dead) { var u = g ? o.v.dataset.end : o.start; if (u && o.v.poster !== u) o.v.poster = u; return; }
      if (!o.raf && o.x !== o.goal) { o.t = 0; o.raf = requestAnimationFrame(o.f); }
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es, ob) {
        if (es.some(function (e) { return e.isIntersecting; })) { list.forEach(wake); ob.disconnect(); }
      }, { rootMargin: '500px 0px' }).observe(row);
    }
    if (matchMedia('(hover:hover)').matches) {
      list.forEach(function (o) {
        o.c.addEventListener('pointerenter', function () { to(o, 1); });
        o.c.addEventListener('pointerleave', function () { to(o, 0); });
      });
    } else if ('IntersectionObserver' in window) {
      var seen = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var o = list.filter(function (x) { return x.c === e.target; })[0];
          if (o) to(o, e.intersectionRatio >= 0.7 ? 1 : 0);
        });
      }, { threshold: [0, 0.7] });
      list.forEach(function (o) { seen.observe(o.c); });
    }
  }

  /* the header is marked sticky but scrolls away with its section, so sticky things measure it live */
  var stickLast = -1;
  function stickTops() {
    var hdr = $('.hdr'), b = 0;
    if (hdr) { b = hdr.getBoundingClientRect().bottom; b = b > 0 ? Math.round(b) : 0; }
    if (b === stickLast) return; stickLast = b;
    $$('.sb-qsec').forEach(function (el) {
      el.style.setProperty('--stick-d', (b + 40) + 'px');
      el.style.setProperty('--stick-m', b + 'px');
      el.style.setProperty('--stick-f', (b + 24) + 'px');
    });
  }

  /* ---------- the four weeks: a calendar that counts the course as the weeks pass ---------- */
  function lum(hex) {
    hex = (hex || '').replace('#', '').trim();
    if (hex.length === 3) hex = hex.split('').map(function (c) { return c + c; }).join('');
    if (hex.length !== 6) return 0;
    function ch(i) { var c = parseInt(hex.substr(i, 2), 16) / 255; return c <= .03928 ? c / 12.92 : Math.pow((c + .055) / 1.055, 2.4); }
    return .2126 * ch(0) + .7152 * ch(2) + .0722 * ch(4);
  }
  function month() {
    var sec = $('.sb-month'); if (!sec) return;
    var cal = $('[data-cal]', sec);
    var cells = $$('.sb-cd', sec), weeks = $$('.sb-mw', sec);
    var num = $('[data-calnum]', sec), wk = $('[data-calwk]', sec);
    if (!cal || !cells.length || !weeks.length) return;

    /* a light week colour takes navy figures, a dark one takes white */
    cells.forEach(function (c) {
      c.style.setProperty('--ink', lum(getComputedStyle(c).getPropertyValue('--wk')) > .36 ? 'var(--navy)' : '#fff');
    });

    if (matchMedia('(prefers-reduced-motion:reduce)').matches) {
      cells.forEach(function (c) { c.classList.add('lit'); });
      weeks.forEach(function (w) { w.classList.add('on'); });
      num.textContent = cells.length;
      return;
    }

    /* only the current week shows its text; the list keeps room for the longest one,
       so nothing below moves while the weeks change */
    var list = $('.sb-mweeks', sec);
    function settle() {
      if (!list) return;
      var gap = parseFloat(getComputedStyle(list).rowGap) || 0, base = gap * (weeks.length - 1), mx = 0;
      weeks.forEach(function (w) {
        var b = $('.sb-mwb', w), t = $('.t-body', w);
        base += w.offsetHeight - (b ? b.offsetHeight : 0);
        if (t) mx = Math.max(mx, t.offsetHeight);
      });
      list.style.minHeight = Math.ceil(base + mx) + 'px';
    }
    function fit() { settle(); measure(); }
    window.addEventListener('resize', fit, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);

    var day = 0, raf = 0;
    /* the month runs while the calendar crosses the screen: day 1 as it comes up from below,
       day 28 just before it reaches the top */
    var grid = $('.sb-mgrid', sec), run = $('.sb-mrun', sec), wideQ = matchMedia('(min-width:1000px)');
    function measure() { if (grid) sec.style.setProperty('--rowh', grid.offsetHeight + 'px'); }
    function progress() {
      var vh = window.innerHeight, p;
      if (wideQ.matches && grid && run && run.offsetHeight) {
        /* wide: from the row coming up into view, through the stretch it holds still in the middle */
        var pad = parseFloat(getComputedStyle(sec).paddingTop) || 0;
        var top = sec.getBoundingClientRect().top + pad;          /* where the row would be if it did not hold */
        var still = Math.max(16, (vh - grid.offsetHeight) / 2);
        var from = vh * 0.8, to = still - run.offsetHeight;
        p = (from - top) / (from - to);
      } else {
        /* phone: while the calendar crosses the screen */
        var ct = cal.getBoundingClientRect().top, f = vh * 0.75, t = vh * 0.08;
        p = (f - ct) / (f - t);
      }
      return p < 0 ? 0 : p > 1 ? 1 : p;
    }
    function paint() {
      raf = 0;
      var n = cells.length, i;
      var d = 1 + Math.floor(progress() * n); if (d > n) d = n;
      if (d === day) return;
      day = d;
      for (i = 0; i < n; i++) {
        cells[i].classList.toggle('lit', i < d);
        cells[i].classList.toggle('now', i === d - 1);
      }
      var w = Math.min(weeks.length, Math.ceil(d / 7));
      weeks.forEach(function (el, i) { el.classList.toggle('on', i === w - 1); el.classList.toggle('done', i < w - 1); });
      num.textContent = d;
      num.classList.remove('tick'); void num.offsetWidth; num.classList.add('tick');
      var cur = weeks[w - 1];
      var lab = $('.sb-wn', cur); if (lab && wk) wk.textContent = lab.textContent;
      cal.style.setProperty('--cur', getComputedStyle(cur).getPropertyValue('--wk'));
    }
    function queue() { if (!raf) raf = requestAnimationFrame(paint); }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    fit();
    paint();
  }


  /* ---------- 03 what's inside: deep -> tint -> cream as the plants come up; the big words slide ---------- */
  function inside() {
    var box = $('[data-ins]'); if (!box) return;
    var p2 = $('.ins-p2', box), mq = $$('[data-mq]', box);
    var calm = matchMedia('(prefers-reduced-motion:reduce)').matches;
    function rgb(v) {
      v = (v || '').trim().replace('#', '');
      if (v.length === 3) v = v.replace(/(.)/g, '$1$1');
      var n = parseInt(v.slice(0, 6), 16); return [n >> 16 & 255, n >> 8 & 255, n & 255];
    }
    var cs = getComputedStyle(box);
    var D = rgb(cs.getPropertyValue('--ins-d')), T = rgb(cs.getPropertyValue('--ins-t')), C = rgb(cs.getPropertyValue('--ins-c'));
    function mix(a, b, t) { return 'rgb(' + a.map(function (x, i) { return Math.round(x + (b[i] - x) * t); }).join(',') + ')'; }
    var raf = 0, last = -1;
    function paint() {
      raf = 0;
      var vh = window.innerHeight, r = box.getBoundingClientRect();
      /* the colour turns while the second screen comes up the page */
      var t = (vh * 0.72 - p2.getBoundingClientRect().top) / (vh * 0.5);
      t = t < 0 ? 0 : t > 1 ? 1 : t;
      if (Math.abs(t - last) > 0.002) {
        last = t;
        box.style.background = t < 0.5 ? mix(D, T, t * 2) : mix(T, C, (t - 0.5) * 2);
        box.style.setProperty('--t', t.toFixed(3));      /* the first screen's white words fade as the colour lightens */
      }
      if (calm) return;
      /* the words slide: the first line to the left, the second to the right, by how far the block has travelled */
      var g = (vh - r.top) / (r.height + vh); g = g < 0 ? 0 : g > 1 ? 1 : g;
      mq.forEach(function (m, i) {
        var w = m.scrollWidth / 3;             /* the words are written three times; one third is one loop */
        var x = (i ? -w + g * w * 0.9 : -g * w * 0.9);
        m.style.setProperty('--mx', x.toFixed(1) + 'px');
      });
    }
    function queue() { if (!raf) raf = requestAnimationFrame(paint); }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    paint();
  }

  /* ---------- promo code: one field on the product page, the drawer and the cart page; the code lives on the cart ---------- */
  var Promo = {
    boxes: [],
    root: function () { return (window.Shopify && Shopify.routes ? Shopify.routes.root : '/'); },
    post: function (code) {
      return fetch(Promo.root() + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: code })
      }).then(function (r) { return r.json(); });
    },
    state: function (c) { Promo.boxes.forEach(function (b) { Promo.show(b, c); }); },
    show: function (box, c, fresh) {
      var on = $('[data-promo-on]', box), row = $('.promo-row', box), err = $('[data-promo-err]', box);
      var codes = (c && c.discount_codes) || [], d = codes[codes.length - 1];
      if (!d) { on.hidden = true; row.hidden = false; return; }
      var known = (box.dataset.known || '').toUpperCase(), pct = +box.dataset.pct || 0, mine = d.code.toUpperCase() === known;
      var msg = '';
      if (d.applicable) {
        msg = c.total_discount ? '<b>&minus;' + money(c.total_discount) + '</b> off this order' : 'applied';
      } else if (!c.item_count) {
        if (mine && box.dataset.cents) msg = '<b>' + money(box.dataset.cents - Math.floor(box.dataset.cents * pct / 100)) + '</b> with the code &middot; ' + pct + '% off';
        else if (mine) msg = pct + '% comes off in the cart';
        else msg = 'saved &middot; it comes off in the cart';
      } else {
        err.textContent = 'This code doesn’t apply to this order.'; err.hidden = false;
        on.hidden = true; row.hidden = false; return;
      }
      err.hidden = true;
      $('[data-promo-code]', box).textContent = d.code.toUpperCase();
      $('[data-promo-msg]', box).innerHTML = msg;
      row.hidden = true; on.hidden = false;
      if (fresh) { on.classList.remove('in'); void on.offsetWidth; on.classList.add('in'); }
    },
    after: function (box, c) {
      if (box.dataset.ctx === 'cart') { location.reload(); return; }
      if (typeof Cart !== 'undefined' && Cart.render && $('#drawer')) Cart.render(c);
      Promo.state(c);
      Promo.boxes.forEach(function (b) { if (b !== box) return; Promo.show(b, c, true); });
    }
  };
  function promo() {
    Promo.boxes = $$('[data-promo]');
    if (!Promo.boxes.length) return;
    Promo.boxes.forEach(function (box) {
      var input = $('[data-promo-input]', box), go = $('[data-promo-apply]', box), err = $('[data-promo-err]', box);
      function apply() {
        var code = (input.value || '').trim().toUpperCase();
        if (!code) { input.focus(); return; }
        go.setAttribute('aria-busy', 'true'); err.hidden = true;
        Promo.post(code).then(function (c) {
          go.removeAttribute('aria-busy');
          var d = (c.discount_codes || []).filter(function (x) { return x.code.toUpperCase() === code; })[0];
          if (!d || (c.item_count && !d.applicable)) {
            err.textContent = c.item_count ? 'This code doesn’t apply to this order.' : 'We couldn’t save that code — check the spelling.';
            err.hidden = false;
            if (d) Promo.post('').then(function (c2) { Promo.state(c2); });
            return;
          }
          input.value = '';
          Promo.after(box, c);
        }).catch(function () { go.removeAttribute('aria-busy'); err.textContent = 'Something went wrong — try again.'; err.hidden = false; });
      }
      go.addEventListener('click', apply);
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); apply(); } });
      $('[data-promo-remove]', box).addEventListener('click', function () {
        Promo.post('').then(function (c) { Promo.after(box, c); });
      });
    });
    fetch(Promo.root() + 'cart.js').then(function (r) { return r.json(); }).then(Promo.state).catch(function () {});
  }

  /* ---------- the 25% pop-up: three cards, one question, the email, the code ---------- */
  function popup() {
    var pop = $('[data-pop]'); if (!pop) return;
    var tab = $('[data-pop-open]');
    var KEY = '7vit-pop', code = pop.dataset.code, days = +pop.dataset.days || 7, delay = (+pop.dataset.delay || 8) * 1000;
    var calm = matchMedia('(prefers-reduced-motion:reduce)').matches;
    function st() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
    function put(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
    var s = st(), goal = s.goal || '';
    if (s.done) return;                                   /* subscribed: never again */
    var last = null;

    function step(n) {
      $$('.pop-step', pop).forEach(function (el) {
        var me = +el.dataset.step === n;
        el.hidden = !me; el.classList.toggle('on', me);
        if (me) { el.classList.remove('in'); void el.offsetWidth; el.classList.add('in'); }
      });
      var f = n === 3 ? $('.pop-step.on input[type="email"]', pop) : $('.pop-in', pop);
      if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 60);
    }
    function open() {
      if (!pop.hidden) return;
      last = document.activeElement;
      pop.hidden = false; document.body.classList.add('pop-open');
      requestAnimationFrame(function () { requestAnimationFrame(function () { pop.classList.add('on'); }); });
      if (tab) tab.hidden = true;
      var f = $('.pop-in', pop); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 80);
      s = st(); s.seen = Date.now(); put(s);
    }
    function close() {
      pop.classList.remove('on'); document.body.classList.remove('pop-open');
      setTimeout(function () { pop.hidden = true; }, calm ? 0 : 320);
      s = st(); s.closed = Date.now(); put(s);
      if (tab && !st().done) tab.hidden = false;
      if (last && last.focus) last.focus({ preventScroll: true });
    }
    $$('[data-pop-close]', pop).forEach(function (b) { b.addEventListener('click', close); });
    pop.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {                            /* keep focus inside */
        var f = $$('button:not([hidden]), input, a[href]', pop).filter(function (x) { return x.offsetParent; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    if (tab) tab.addEventListener('click', open);

    /* 1 — three cards, and they match */
    var turned = [], box = $('.pop-cards', pop);
    $$('.pop-card', pop).forEach(function (c) {
      c.addEventListener('click', function () {
        if (c.classList.contains('up') || turned.length >= 3) return;
        c.classList.add('up'); turned.push(c);
        if (turned.length === 3) {
          box.classList.add('done');
          setTimeout(function () { turned.forEach(function (t, k) { t.style.setProperty('--k', k); t.classList.add('win'); }); }, calm ? 0 : 560);
          setTimeout(function () { step(2); }, calm ? 300 : 1500);
        }
      });
    });
    /* 2 — what are you after */
    $$('.pop-opt', pop).forEach(function (b) {
      b.addEventListener('click', function () { goal = b.dataset.goal; s = st(); s.goal = goal; put(s); step(3); });
    });
    /* 3 — the email goes to Shopify as a newsletter subscriber. The form posts for real (not by fetch):
       Shopify's spam check (hCaptcha) only signs a genuine submit. It comes back with ?customer_posted=true,
       and the pop-up reopens on the code. */
    var form = $('.pop-form', pop), err = $('.pop-err', pop);
    if (form) form.addEventListener('submit', function (e) {
      var input = $('input[type="email"]', form), v = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { e.preventDefault(); err.hidden = false; input.focus(); return; }
      err.hidden = true;
      var tags = $('[data-pop-tags]', form); if (tags) tags.value = 'newsletter,popup' + (goal ? ',goal-' + goal : '');
      $('.pop-go', form).setAttribute('aria-busy', 'true');
      s = st(); s.pending = Date.now(); s.goal = goal; put(s);
    });
    /* 4 — copy */
    var cp = $('[data-pop-copy]', pop);
    if (cp) cp.addEventListener('click', function () {
      var t = $('span', cp);
      (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).then(function () {
        var was = t.textContent; t.textContent = t.dataset.t; setTimeout(function () { t.textContent = was; }, 1600);
      }).catch(function () {});
    });

    /* back from the post: the code, already on the cart */
    if (s.pending && /customer_posted=true/.test(location.search + location.hash)) {
      s.done = Date.now(); delete s.pending; put(s);
      /* the code goes onto the cart, and every promo field on the page shows it */
      Promo.post(code).then(Promo.state).catch(function () {
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
      });
      var shop = $('[data-pop-shop]', pop);
      if (shop && goal && shop.dataset[goal]) shop.href = shop.dataset[goal];
      open(); step(4); return;
    }
    if (s.pending && Date.now() - s.pending < 6e5) { delete s.pending; put(s); open(); step(3); err.hidden = false; return; }
    /* the "25% off" tag is always there until the visitor subscribes; the window itself opens once, after a
       few seconds or when the pointer heads for the tabs; closed recently -> only the tag */
    if (tab) tab.hidden = false;
    if (s.closed && Date.now() - s.closed < days * 864e5) return;
    var t = setTimeout(open, delay);
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0 && pop.hidden && !st().closed) { clearTimeout(t); open(); }
    });
  }

  /* each part starts on its own: one that fails must not take the rest of the page down with it */
  function boot() {
    [reveal, counters, slider, media, grams, variants, qty, cart, sbar, rails, menus, weeks, reel, sellfaq, cmpbg, qfilm, month, inside, promo, popup, bloom]
      .forEach(function (f) { try { f(); } catch (e) { if (window.console) console.error('7vit:', f.name, e); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
